import { Link } from "@/lib/router";
import { LEGAL } from "@/lib/legal/config";

/**
 * 2026-09-26에 점검한 문서다. 변호사 검토를 거친 문서가 아니므로 공개 전에 전문가 검토를 받을 것.
 * 유료 플랜을 도입할 때는 요금·결제·환불 조항과 사업자 정보(통신판매업 신고 등)를 추가해야 한다.
 */
export default function TermsPage() {
  return (
    <>
      <div>
        <h1>이용약관</h1>
        <p className="mt-2 text-muted-foreground">시행일: {LEGAL.version}</p>
      </div>

      <section className="flex flex-col gap-2">
        <h2>1. 서비스</h2>
        <p>
          {LEGAL.serviceName}은 이용자가 올린 설교 노트 사진을 AI로 정리하고, 개인의 실천을 기록하며, 지난
          노트를 찾아볼 수 있게 돕는 개인 기록 서비스입니다. 특정 교단·교리를 대표하지 않으며 신학적 판단을
          제공하지 않습니다.
        </p>
      </section>

      <section className="flex flex-col gap-2">
        <h2>2. 계정</h2>
        <ul>
          <li>만 14세 이상이 이메일로 가입할 수 있으며, 계정과 비밀번호 관리는 이용자의 책임입니다.</li>
          <li>이용자는 설정 화면에서 언제든지 탈퇴할 수 있고, 탈퇴하면 모든 데이터가 삭제되어 복구할 수 없습니다.</li>
          <li>가입 시 입력한 정보는 사실과 같아야 하며, 타인의 이메일로 가입할 수 없습니다.</li>
        </ul>
      </section>

      <section className="flex flex-col gap-2">
        <h2>3. 이용자의 콘텐츠</h2>
        <ul>
          <li>올린 노트의 권리는 이용자에게 있으며, 운영자는 서비스 제공에 필요한 범위에서만 처리합니다.</li>
          <li>타인의 저작물·개인정보가 담긴 자료나 불법적인 자료를 올리지 마세요.</li>
          <li>
            노트 사진과 그로부터 읽어낸 글은 요약·검색을 위해 AI 서비스 업체(Google, OpenAI)로 전송됩니다.
            자세한 내용은 개인정보 처리방침을 참고하세요.
          </li>
        </ul>
      </section>

      <section className="flex flex-col gap-2">
        <h2>4. AI 결과의 한계</h2>
        <ul>
          <li>요약·마인드맵·실천 후보는 AI가 만든 것이라 사진의 글을 잘못 읽거나 빠뜨릴 수 있으니 원본과 비교해 확인해 주세요.</li>
          <li>&quot;AI가 추천한 실천&quot;은 참고용이며, 무엇을 실천할지는 이용자가 정합니다.</li>
          <li>설교 노트로 보이지 않는 사진은 저장되지 않을 수 있습니다.</li>
        </ul>
      </section>

      <section className="flex flex-col gap-2">
        <h2>5. 성경 본문</h2>
        <p>
          서비스에 표시되는 성경 본문의 저작권은 해당 번역본의 저작권자에게 있습니다. 운영자는 저작권자의 사용
          허락을 받은 번역본에 한해, 허락된 범위 안에서 출처를 밝혀 본문을 표시합니다. 허락을 받지 않은 번역본의
          본문은 표시하지 않습니다. 자세한 내용은{" "}
          <Link href="/scripture-copyright" className="underline underline-offset-4">
            성경 본문 저작권 안내
          </Link>
          를 참고하세요.
        </p>
      </section>

      <section className="flex flex-col gap-2">
        <h2>6. 이용 한도와 이용 제한</h2>
        <ul>
          <li>노트 사진은 JPG, PNG, WEBP, HEIC 형식, 4MB 이하만 올릴 수 있습니다.</li>
          <li>무료 플랜은 한 달에 노트 3개까지 새로 만들 수 있으며, 매달 1일(한국 시간)에 초기화됩니다.</li>
          <li>
            서비스를 부당하게 이용해 다른 이용자나 서비스에 피해를 주는 경우(자동화된 대량 요청, 비정상적인
            반복 업로드 등) 이용을 제한하거나 계정을 정지할 수 있습니다. 이 경우 사전에 이메일로 알리며, 서비스의
            안정성을 급히 지켜야 하는 경우에는 먼저 조치한 뒤 알립니다.
          </li>
        </ul>
      </section>

      <section className="flex flex-col gap-2">
        <h2>7. 유료 서비스</h2>
        <p>
          지금은 모든 기능을 무료로 제공합니다. 유료 플랜을 도입하게 되면 요금, 결제, 환불 등의 조건을 미리
          공지하고 이용자의 별도 동의를 받은 뒤에 적용합니다. 이미 만든 노트는 유료 플랜 도입 때문에 삭제되지
          않습니다.
        </p>
      </section>

      <section className="flex flex-col gap-2">
        <h2>8. 서비스 변경·중단, 책임 제한</h2>
        <p>
          서비스는 개인이 운영하며 기능이 바뀌거나 중단될 수 있습니다. 서비스를 중단하는 경우 이용자가 자신의
          노트를 확인할 수 있도록 사전에 알립니다. 운영자는 운영자의 고의 또는 중대한 과실이 있는 경우를 제외하고,
          천재지변, 외부 서비스(Google, OpenAI, Supabase, Vercel 등)의 장애처럼 운영자가 통제할 수 없는 사유로
          생긴 손해에 대해 법령이 허용하는 범위에서 책임을 지지 않습니다.
        </p>
      </section>

      <section className="flex flex-col gap-2">
        <h2>9. 약관의 변경</h2>
        <p>
          약관을 바꾸는 경우 적용일 7일 전부터 서비스 화면에 공지합니다. 이용자에게 불리한 변경은 적용일 30일
          전부터 공지하고, 필요하면 다시 동의를 받습니다. 변경에 동의하지 않는 이용자는 언제든지 탈퇴할 수 있습니다.
        </p>
      </section>

      <section className="flex flex-col gap-2">
        <h2>10. 준거법과 분쟁 해결</h2>
        <p>
          이 약관은 대한민국 법에 따라 해석됩니다. 서비스와 관련해 분쟁이 생기면 먼저 아래 문의처로 연락해
          협의하고, 해결되지 않으면 민사소송법에 따른 관할 법원에서 다룹니다.
        </p>
      </section>

      <section className="flex flex-col gap-2">
        <h2>11. 문의</h2>
        <p>
          운영자: {LEGAL.operatorName} / 이메일: {LEGAL.contactEmail}
        </p>
      </section>
    </>
  );
}
